













import DeviceInfoTable from '@/views/deviceInfo/unit/device-info-table.vue';
import DeviceInfoDetail from '@/views/deviceInfo/unit/device-info-detail.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { DeviceInfoTable, DeviceInfoDetail },
})
export default class DeviceInfo extends Vue {
  flag = 1; // 控制显示主页组件还是编辑和新增组件,1：index页面 2：编辑页面 3：新增页面
  row = ''; // index组件向编辑组件传值
  helpType = ''; //
  getHelpType(data: any) {
    this.helpType = data;
  }
}
